import type { FaireProductEntity } from "../../entity_types/product";

export const p_8asv5674yu: FaireProductEntity = {
  token: "p_8asv5674yu",
  type: "product",
  name: "ONE Mini Gem Aquamarine Crystal Sphere, 16mm to 26mm",
  brandToken: "b_rt8fmuccyw",
  brandName: "Caspar Curiosities",
  imageUrl:
    "https://cdn.faire.com/fastly/285d12be8ccf59ec2b45f6cc436c884bbfcecd9dc4ca9f15d14f909ebee49cc0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dface719ad2fe1a7477df73d61f94034f09aa21917267dea67b09ede94600bbd.jpeg",
    "https://cdn.faire.com/fastly/04d7f81308a7e191f15bf6a0d3c72626074b5133a1ff16a7f913e7b56bf39e67.jpeg",
    "https://cdn.faire.com/fastly/226d3d06ff47e773fb9bdd04041fb63e5968e5c9d62042be2e6d70398fd652fb.jpeg",
    "https://cdn.faire.com/fastly/0d37ebb05060452fec7c80264d3fc8ee4317ffcaf4d5312297de776a63225ff2.jpeg",
    "https://cdn.faire.com/fastly/0a236d614f43a56b764b8044e49d5d75d4c0699492d1a1377ca7a9a1e8e17937.jpeg",
    "https://cdn.faire.com/fastly/51048209b884ccd3b5fbd300f735f97472efc6f915c0697723a0b3ff2a3dd3d1.jpeg",
    "https://cdn.faire.com/fastly/694fc5b1f766fa44707392f67d033ced1e4f1801b647e5c9ae9f8f45dc7cd7d4.jpeg",
    "https://cdn.faire.com/fastly/8512a7c620a2b86e166633d155cff7993e0e7e2fcfeb2911e0ae1b0eaf8d5bba.jpeg",
  ],
  priceDollars: 10.5,
  description:
    "For your consideration are these beautiful mini Aquamarine crystal spheres, sold by the piece. These are very gemmy with incredible color. I have photographed several to illustrate variation.\n\nThese are available in several sizes. These spheres are NOT calibrated- so please keep in mind that sizes are approximate.\n16mm to 18mm weighing 5 to 8 grams\n18mm to 20mm weighing 9 to 12 grams\n20mm to 22mm weighing 13 to 16 grams\n22mm to 24mm weighing 17 to 20 grams\n24mm to 26mm weighing 21 to 25 gram\n\nAquamarine is a stone of Empowerment.  It is a doorway to communication with Goddess energy and wisdom.  Aquamarine facilitates the expression of one’s highest truth.  This crystal cools hot emotions such as anger and frustration.  Believed to be mermaid’s treasure in the old world, it has been used as a talisman for luck, protection, eternal youth and happiness.\nChakras:  Throat (5th), Heart (4th)",
  tags: [],
  msrpDollars: 21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:43.121Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
